import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";
import { Landmark, CalendarClock, ExternalLink, Info } from "lucide-react";

export default function Impots() {
  const [calendar, setCalendar] = useState(null);
  const [help, setHelp] = useState(null);

  useEffect(() => {
    api.get("/legal/tax-calendar").then((r) => setCalendar(r.data)).catch(() => {});
    api.get("/legal/tax-help").then((r) => setHelp(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6 adminia-fade-in">
      <div>
        <h1 className="font-heading font-bold text-2xl sm:text-3xl">Assistant Impôts</h1>
        <p className="text-muted-foreground mt-1">Comprenez chaque case et suivez le calendrier officiel.</p>
      </div>

      <div className="flex items-start gap-2 rounded-xl bg-brand/5 border border-brand/20 p-4 text-sm">
        <Info className="h-5 w-5 text-brand shrink-0 mt-0.5" />
        <p>{calendar?.disclaimer || "Information à titre indicatif — à vérifier sur le site officiel."} Données internes v{calendar?.version}.</p>
      </div>

      {/* Calendrier */}
      <div>
        <h2 className="font-heading font-semibold text-lg mb-3 flex items-center gap-2">
          <CalendarClock className="h-5 w-5 text-brand" /> Calendrier fiscal
        </h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {calendar?.items.map((it) => (
            <Card key={it.id} className="p-5" data-testid={`tax-cal-${it.id}`}>
              <p className="font-heading font-semibold">{it.titre}</p>
              <p className="text-sm text-brand font-medium mt-1">{it.periode}</p>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{it.details}</p>
              <a href={it.source_url} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-1 text-xs text-brand mt-3 font-medium">
                {it.source} <ExternalLink className="h-3 w-3" />
              </a>
            </Card>
          ))}
        </div>
      </div>

      {/* Aide aux cases */}
      <div>
        <h2 className="font-heading font-semibold text-lg mb-3 flex items-center gap-2">
          <Landmark className="h-5 w-5 text-brand" /> Comprendre les cases
        </h2>
        <Card className="p-2 sm:p-4">
          <Accordion type="single" collapsible>
            {help?.items.map((h, i) => (
              <AccordionItem key={i} value={`case-${i}`} data-testid={`tax-help-${i}`}>
                <AccordionTrigger className="text-left">
                  <span><span className="font-mono font-semibold text-brand mr-2">{h.case}</span>{h.libelle}</span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">{h.explication}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Card>
      </div>
    </div>
  );
}
